export default __webpack_public_path__ + "static/media/erc-logo.a80f7f04.png";